import React from "react";

const CodeLoading = (props) => {
	if (props.error) {
		console.log(props.error);
		return <div>Sorry, there was a problem loading the page.</div>;
	} else if (props.pastDelay) {
		return null;
	} else {
		return null;
	}
};

export default CodeLoading;